import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { Glyphicon } from 'react-bootstrap';

const links = [{
  href: '/dashboard',
  label: 'Dashboard',
  icon: 'dashboard',
}, {
  href: '/general',
  label: 'General',
  icon: 'picture',
}, {
  href: '/links',
  label: 'Links',
  icon: 'link',
}, {
  href: '/sections',
  label: 'Sections',
  icon: 'th-list',
}, {
  href: '/banners',
  label: 'Banners',
  icon: 'bullhorn',
}, {
  href: '/users',
  label: 'Users',
  icon: 'user',
}, {
  href: '/icons',
  label: 'Icons',
  icon: 'list-alt',
}];

function renderLinks (link, index) {
  return (
    <Fragment key={`link-${index}-sidebar`}>
      {
        (+localStorage.getItem('roleId') === 2) && link.label === "Banners"
        ? <li key={`link-${index}-roleId`}>
            <NavLink 
              to={link.href}
              activeClassName="active"
            >
              <Glyphicon
                glyph={link.icon}
              />
              {link.label}
            </NavLink>
          </li>
        : <li key={`link-${index}-rolesidebar`}>
            <NavLink 
              to={link.href}
              activeClassName="active"
            >
              <Glyphicon
                glyph={link.icon}
              />
              {link.label}
            </NavLink>
          </li>
      }
    </Fragment>
  )
}

const Sidebar = () => (
  <div className="sidebar">
    <div className="sidebar__sections">
      <ul>
        {links.map(renderLinks)}
      </ul>
    </div>
  </div>
);

export default Sidebar;



// WEBPACK FOOTER //
// ./src/app/components/complex/sidebar.js